import _ from 'lodash'

export function cleanLayoutTenderTypes (layout, settingsBlob) {
  const tenderTypes = _.get(settingsBlob, 'tenderTypes', [])
    .filter(next => !next.disabled)
    .map(next => next.id)

  for (let layoutTab of _.values(layout.tabs)) {
    for (let button of _.values(layoutTab.buttons)) {
      const tenderTypeId = _.get(button, 'typeInfo.tenderInfo.tenderTypeId')
      if (tenderTypeId && !tenderTypes.includes(tenderTypeId)) {
        if (button.type === 'TENDER') {
          delete layoutTab.buttons[button.index]
        } else {
          button.typeInfo.tenderInfo.tenderTypeId = null
        }
      }
    }
  }
}
